export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UnderConstruction.vue?vue&type=template&id=32531a8b&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/UnderConstruction.vue?vue&type=template&id=32531a8b&
// module id = 1591
// module chunks = 0